module.exports = __webpack_public_path__ + "static/img/Originallogo_zurqui.81ced98c.png";